import { useParams } from "react-router-dom";
import { SideTabsPage } from "@/components/shared";
import { settingsTabs } from "@/components/admin/settings";

const AdminSettings = () => {
  const { tabId } = useParams<{ tabId?: string }>();

  return (
    <SideTabsPage
      title="Settings"
      description="Platform configuration, referral levels, email, integrations and database backups."
      basePath="/admin/settings"
      tabs={settingsTabs}
      tabId={tabId}
    />
  );
};

export default AdminSettings;
